import wx from 'weixin-js-sdk'
import {System} from '../config/route-fetch';
import StorageUtil from './storage-util';
import {SystemConst} from "./constant";
import {BusinessUtil} from "./BusinessUtil";

let sha1 = require('js-sha1');

const ua = (localStorage.getItem('wkData-webUA') || window.navigator.userAgent).toLowerCase();

// 最好在在 router 的全局钩子里调用这个方法，每次页面的 URL 发生变化时，都需要重新获取微信分享参数
// 如果你的 router 使用的是 hash 形式，应该不用每次都重新获取微信分享参数
const loadWxConfig = () => {
    //如果不是在微信
    if (ua.indexOf('micromessenger') < 0) return false;

    function buildSignature(noncestr, timestamp, ticket) {
        let url = location.href.split('#')[0];
        console.log('noncestr', noncestr)
        console.log('timestamp', timestamp)
        console.log('ticket', ticket)
        console.log('url', url)
        return sha1(`jsapi_ticket=${ticket}&noncestr=${noncestr}&timestamp=${timestamp}&url=${url}`)
    }

    let noncestr = Math.random().toString(32).substr(2);
    let timestamp = parseInt(new Date().getTime() / 1000);
    System.getWxTicket({}, rs => {
        // console.log('rs', rs);
        if (rs.status === 1 && rs.data) {
            //生成微信加密
            wx.config({
                debug: false,
                appId: rs.data.appId,
                timestamp: timestamp,
                nonceStr: noncestr,
                signature: buildSignature(noncestr, timestamp, rs.data.ticket),
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'scanQRCode', 'updateAppMessageShareData', 'updateTimelineShareData'],
                openTagList:['wx-open-launch-weapp']
            });
        }
    })

};

//分享商品详情重写
const goodsShare = (data) => {
    if (ua.indexOf('android') > -1) {
        loadWxConfig();
    }

    setTimeout(() => {
        const user = StorageUtil.getItem(SystemConst.mShop_user);
        let search = location.search;
        if (user) {
            search += `&c=${user.client_id_}`
        }
        const url_ = BusinessUtil.appendShopCloneEntryToUrl(location.origin + location.pathname + search);
        let shareData = {
            title: data.name_,
            desc: `${StorageUtil.getItem(SystemConst.companyName)}有一个不错的商品，快来看一下`,
            imgUrl: data.main_img_ || SystemConst.shareDefaultLogo,
            link: url_
        };

        wx.ready(function (res) {
            // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
            wx.onMenuShareTimeline({
                ...shareData,
                success: function (res) {
                    console.log('success');
                }
            });
            // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
            wx.onMenuShareAppMessage({
                ...shareData,
                success: function (res) {
                    console.log('success')
                }
            });
            wx.onMenuShareQQ({
                ...shareData,
                success: function () {
                    // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });

        });
    }, 1500);

};

//分享企业信息+当前url
const pageShare = () => {
    if (ua.indexOf('android') > -1) {
        loadWxConfig();
    }
    setTimeout(() => {
        let shopSetting = StorageUtil.getItem(SystemConst.shopSetting) || {};
        let url_ = BusinessUtil.appendShopCloneEntryToUrl(location.href);
        let shareData = {
            title: StorageUtil.getItem(SystemConst.companyName),
            desc: shopSetting.share_introduce_ || '暂未设置',
            imgUrl: shopSetting.share_logo_ || SystemConst.shareDefaultLogo,
            link: url_
        };
        wx.ready(function (res) {
            // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
            wx.onMenuShareTimeline({
                ...shareData,
                success: function (res) {
                    console.log('success')
                }
            });
            // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
            wx.onMenuShareAppMessage({
                ...shareData,
                success: function (res) {
                    console.log('success')
                }
            });
            wx.onMenuShareQQ({
                ...shareData,
                success: function () {
                    // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
        });
    }, 1500)
};

// 微信扫一扫
const wxScanQRCode = (callback) => {
    wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
            var result = res.resultStr.split(","); // 当needResult 为 1 时，扫码返回的结果
            // alert("扫描结果：" + result);
            callback && callback(result[result.length - 1])
        }

    });
    wx.error(function (res) {
        alert(JSON.stringify(res));
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    });
};

// 分享小程序卡片（砍一刀专用）
const shareMiniProgram = (data) => {
    if (ua.indexOf('android') > -1) {
        loadWxConfig();
    }
    setTimeout(() => {
        wx.ready(function () {
            // 使用新接口更新分享内容
            wx.updateAppMessageShareData({
                title: data.title || '帮我砍一刀',
                desc: data.desc || '帮忙砍个价，谢谢啦！',
                link: data.link,  // 小程序URL Link或H5链接
                imgUrl: data.imgUrl || SystemConst.shareDefaultLogo,
                success: function () {
                    console.log('分享配置成功');
                    data.success && data.success();
                },
                fail: function (err) {
                    console.log('分享配置失败', err);
                    data.fail && data.fail(err);
                }
            });
        });
    }, 1500);
};

export {loadWxConfig, goodsShare, pageShare, wxScanQRCode, shareMiniProgram}



// WEBPACK FOOTER //
// ./src/utils/WechatUtil.js